'use client'

import Breadcrumbs from '@components/breadcrumbs'
import Container from '@components/container'
import type { TypeBreadcrumbBlockFields } from '@lib/generated-types'
import omit from 'lodash/omit'
import { routeMapper, menuItemMapper } from '@lib/menu-item-mapper'
import { Button } from '@shc/ui'

const BreadcrumbBlock = ({
  internalName,
  breadcrumbs,
  buttonLabel,
  buttonAnchorOrExternalLink,
  buttonLink,
  ...props
}: TypeBreadcrumbBlockFields) => {
  const link = routeMapper(buttonLink, buttonAnchorOrExternalLink)
  const breadcrumbsArr = typeof breadcrumbs !== 'undefined' ? breadcrumbs?.map(menuItemMapper) : []
  return (
    <Container
      className={'h-20 container breadcrumb mx-auto flex flex-row flex-nowrap justify-between items-center'}
    >
      <Breadcrumbs
        breadcrumbs={breadcrumbsArr}
        {...omit(props, ['internalName'])}>
      </Breadcrumbs>
      { buttonLabel && link.route && (
        <Button
          href={link.route}
          target={link.isInternal ? undefined : '_blank'}
          rel={link.isInternal ? undefined : 'noopener noreferrer'}
          variant="outlined"
          width="auto"
          size="xs">
          {buttonLabel}
        </Button>
      )}
    </Container>
  )
}

export default BreadcrumbBlock
